import React, { Component } from "react";
import { RiArrowUpSLine, RiArrowDownSLine } from "react-icons/ri";
import Axios from "axios";
import toastr from "toastr";

import DefaultHeader from "components/main/DefaultLayout/DefaultHeader";
import DefaultFooter from "components/main/DefaultLayout/DefaultFooter";
import BoardHeader from "../Layout/ReferenceHeader";
import * as Service from "services/RestAPI";

import stl from "./ReferenceDetail.module.scss";
import "./quill.snow.css";

class ReferenceDetail extends Component {
	stats = {
		ntNo: 0,
		ntTitle: "",
		ntAuthor: "",
		ntDt: "",
		ntContents: "",
		nextNo: 0,
		prevNo: 0,
		nextTitle: "",
		prevTitle: "",
		ntFileName: "",
		ntOriFileName: "",
		ntFileSize: 0,
		ntFilePath: "",
	};

	componentDidMount() {
		const noticeId = window.location.href.split("/")[4];
		this._init(noticeId);
		// console.log(this.props);
	}

	_init = async (id) => {
		await Service.getReferenceDetail(id).then((res) => {
			// console.log(res);
			this.setState({
				ntNo: res.data.ntNo,
				ntTitle: res.data.ntTitle,
				ntAuthor: res.data.ntAuthor,
				ntDt: res.data.ntDt,
				ntContents: res.data.ntContent,
				nextNo: res.data.nextNo,
				prevNo: res.data.prevNo,
				nextTitle: res.data.nextTitle,
				prevTitle: res.data.prevTitle,
				ntFileName: res.data.ntFileName,
				ntOriFileName: res.data.ntOfileName,
				ntFileSize: res.data.ntFileSize,
				ntFilePath: res.data.ntFilePath,
			});
		});
	};

	// 게시글 이동(이전글, 다음글)
	goReferenceDetail = (gbn, id) => {
		if (id === 0) {
			alert(`${gbn === "prev" ? "이전글이 존재하지 않습니다." : "다음글이 존재하지 않습니다."}`);
			return;
		}
		window.location.href = "/reference/" + id;
	};

	// 목록 버튼 클릭 시
	toList = () => {
		this.props.history.push("/reference");
	};

	handleFileDown = async (id, fileName) => {
		const link = document.createElement("a");
		document.body.appendChild(link);
		link.setAttribute("download", true);
		link.href = "/api/fileReferenceDown?id=" + id;
		link.click();
		document.body.removeChild(link);
	};

	render() {
		return (
			<div>
				<DefaultHeader />
				<BoardHeader />
				{this.state && (
					<div className={stl.noticeContainer}>
						<div className={stl.noticeWrapper}>
							<div className={stl.noticeInfo}>
								<div className={stl.title}>
									<span className={`${stl.left} ${stl.text}`}>{this.state.ntTitle}</span>
								</div>
								<div className={stl.info}>
									<span className={`${stl.left} ${stl.bot}`}>작성일 : {this.state.ntDt}</span>
									<br />
									<span className={`${stl.left} ${stl.bot}`}>작성자 : {this.state.ntAuthor}</span>
								</div>
							</div>
							<div className={stl.noticeFile}>
								{this.state.ntOriFileName && (
									<div className={stl.fileWrapper}>
										<div className={stl.downBtn} onClick={() => this.handleFileDown(this.state.ntNo, this.state.ntOriFileName)}>
											다운로드
										</div>
										<div className={stl.fileName}>{this.state.ntOriFileName}</div>
									</div>
								)}
							</div>
							<div className={stl.noticeContents}>
								<div className="ql-container ql-snow" style={{ border: "0px" }}>
									<div className="ql-editor" dangerouslySetInnerHTML={{ __html: this.state.ntContents }}></div>
								</div>
							</div>
							<div className={stl.noticeMove}>
								<div className={`${stl.noticeList} ${stl.prev}`} onClick={() => this.goNoticeDetail("prev", this.state.prevNo)}>
									<div className={stl.arrow}>
										<RiArrowUpSLine />
									</div>
									<div className={stl.gbn}>이전글</div>
									<div className={stl.title}>{this.state.prevTitle}</div>
								</div>
								<div className={`${stl.noticeList} ${stl.next}`} onClick={() => this.goNoticeDetail("next", this.state.nextNo)}>
									<div className={stl.arrow}>
										<RiArrowDownSLine />
									</div>
									<div className={stl.gbn}>다음글</div>
									<div className={stl.title}>{this.state.nextTitle}</div>
								</div>
							</div>
							<div className={stl.toList}>
								<div className={stl.toListBtn} onClick={this.toList}>
									목록
								</div>
							</div>
						</div>
					</div>
				)}
				<DefaultFooter showSite />
			</div>
		);
	}
}

export default ReferenceDetail;
